import { render, staticRenderFns } from "./AssessmentMarksModal.vue?vue&type=template&id=46ac74f9"
import script from "./AssessmentMarksModal.vue?vue&type=script&lang=js"
export * from "./AssessmentMarksModal.vue?vue&type=script&lang=js"
import style0 from "./AssessmentMarksModal.vue?vue&type=style&index=0&id=46ac74f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports